import React from 'react';
import {Link} from 'react-router-dom';

class HighLightPromotion extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {img: require('assets/images/fair/promotion.png'), link: ''},
        {img: require('assets/images/fair/promotion.png'), link: ''},
        {img: require('assets/images/fair/promotion.png'), link: ''},
        {img: require('assets/images/fair/promotion.png'), link: ''},
      ]
    }
  }

  render() {
    return (
      <section className='highlight-promotion-container'>
        <h2 className='hinghlight-title'><span className='red-title'>CÁC KHUYẾN MÃI&nbsp;</span>KHÁC</h2>
        <div className='highlight-promotion-list-img'>
        {
          this.state.data.map((promotion, i) => {
            return(
              <Link className='promotion-img-wrap' to={promotion.link}>
                <img className='promotion-img' src={promotion.img}/>
              </Link>
            )
          })
        }
        </div>
      </section>
    );
  }
}

export default HighLightPromotion;


// WEBPACK FOOTER //
// ./components/fair/sub-view/promotion/HighLightPromotion.jsx